// Import the shop generator
import { generateShops } from './generateShops';

// Generate 1000 shops for Bandar Sri Indah
export const dummyShops = generateShops(69, 4.2738396,118.0129159);